export default __webpack_public_path__ + "static/media/shoppage-package5.834c8b2d.svg";